import { useRef } from 'react'
import isEqual from 'lodash.isequal'

/**
 * React uses object equality to determine if a component should re-render.
 * This can cause issues when the object is a new reference but has the same values.
 * This hook specifically helps when a setter is called with the same value.
 *
 * const object1 = { a: 1 }
 * const object2 = { a: 1 }
 * const reactEqual = object1 === object2 // false
 *
 * This hook allows you to memoize a value using deep equality.
 * const object1 = { a: 1 }
 * const deepEquality
 */
export default function useDeepEqualMemoization(value) {
  const ref = useRef(value)
  if (!isEqual(value, ref.current)) {
    ref.current = value
  }
  return ref.current
}
